import PartnerDirectory from "../components/PartnerDirectory";
import { Compass, Layers, PenTool, Building2 } from "lucide-react";

const FEATURES = [
    { icon: Compass, title: "Site & Master Planning", desc: "Feasibility studies, land utilisation, zoning, RERA compliance and building bye-law expertise." },
    { icon: PenTool, title: "Architectural Design", desc: "3D concepts, elevations, floor plans and material palettes tailored to your vision and budget." },
    { icon: Layers, title: "Turnkey Execution", desc: "From sanction drawings and MCG/NMC approvals to on-site supervision — one accountable partner." },
    { icon: Building2, title: "Commercial & Residential", desc: "Homes, farmhouses, retail plazas, restaurants, hospitals — proven across scales and typologies." },
];

export default function Architects() {
    return (
        <PartnerDirectory
            role="architect"
            roleLabel="Architects"
            roleLabelSingular="Architect"
            path="/architects"
            heroTag="Design & Planning"
            heroTitle={<>Design a home that <span className="text-gold-500">stands the test of time.</span></>}
            heroSubtitle="Council-of-Architecture registered professionals handling every phase — from concept to occupancy certificate — for homes, farmhouses, plots and commercial builds across India."
            features={FEATURES}
            jsonLdCategory="ProfessionalService"
        />
    );
}
